import request from '@/plugins/http'

export function LoginApi(param) {
    return request.post('/api/login/actOperate', param);
}
